import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        timeline: {
            current: 11,
            data: []
        },
        depths: {
            data: []
        },
        works: {
            data: []
        },
        managers: {
            data: []
        },
        pages: {
            data: []
        },
        cats: {
            data: []
        },
        points: {
            type: 'FeatureCollection',
            features: []
        },
        pointNames: {
            data: []
        },
        groupping: {
            current: "depth"
        },
        filter: {
            show: false,
            depth: [],
            works: [],
            manager: [],
        },
    },
    getters: {
        getPage: state => id => state.pages.data.find(val => val.id == id),
        getCat: state => id => state.cats.data.find(val => val.id == id),
        getManager: state => id => state.managers.data.find(val => val.id == id),
        getDepth: state => id => state.depths.data.find(val => val.id == id),
        getWork: state => id => state.works.data.find(val => val.id == id),
    },
    actions: {
        async worksLoader({ state }) {
            return new Promise((resolve, reject) => {
                axios.get('http://testsite.vyatgeo.ru/wp-json/geopoints/v1/worktype')
                .then(response => {
                    state.works.data = response.data
                    resolve()
                }).catch(reject)
            });
        },
        async depthsLoader({ state }) {
            return new Promise((resolve, reject) => {
                axios.get('http://testsite.vyatgeo.ru/wp-json/geopoints/v1/deep')
                .then(response => {
                    state.depths.data = response.data
                    resolve()
                }).catch(reject)
            });
        },
        // eslint-disable-next-line
        async pointsLoader({ state }) {
            return new Promise((resolve, reject) => {
                axios.get('http://testsite.vyatgeo.ru/wp-json/geopoints/v1/points')
                .then(response => {
                    // сохраняем точки в объект vue
                    state.points.features = response.data;
                    resolve()
                }).catch(reject)
            });
        },
        async pagesLoader({ state }) {
            return new Promise((resolve, reject) => {
                axios.get('http://testsite.vyatgeo.ru/wp-json/geopoints/v1/posts')
                .then(response => {
                    state.pages.data = response.data
                    resolve()
                }).catch(reject)
            });
        },
        async catsLoader({ state }) {
            return new Promise((resolve, reject) => {
                axios.get('http://testsite.vyatgeo.ru/wp-json/geopoints/v1/cats')
                .then(response => {
                    state.cats.data = response.data
                    resolve()
                }).catch(reject)
            });
        },
        async managersLoader({ state }) {
            return new Promise((resolve, reject) => {
                axios.get('http://testsite.vyatgeo.ru/wp-json/geopoints/v1/headman')
                .then(response => {
                    state.managers.data = response.data
                    resolve()
                }).catch(reject)
            });
        },
        async timelineLoader({ state }) {
            return new Promise((resolve, reject) => {
                axios.get('http://testsite.vyatgeo.ru/wp-json/geopoints/v1/workdate')
                .then(response => {
                    state.timeline.data = response.data
                    resolve()
                }).catch(reject)
            });
        },
        async pointNamesLoader({ state }) {
            return new Promise((resolve, reject) => {
                axios.get('???https://archaeology.vyatgeo.ru/api/admin/works?names=true')
                .then(response => {
                    state.pointNames.data = response.data
                    resolve()
                }).catch(reject)
            });
        },
        // eslint-disable-next-line
        async getPage({ }, data) {
            axios.get(`http://testsite.vyatgeo.ru/wp-json/geopoints/v1/posts/${data.page.id}`)
                .then(response => {
                    data.page.content = response.data.content
                })
        },
        // eslint-disable-next-line
        async getCat({ }, data) {
            axios.get(`http://testsite.vyatgeo.ru/wp-json/geopoints/v1/cats/${data.page.id}`)
                .then(response => {
                    data.page.content = response.data.content
                });
        },
    }
  })
